import { ReactNode, useCallback, useEffect, useState } from 'react';
import React from 'react';
import { login, logout } from '../store/actions/authentication';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { AuthenticationParams } from '../repositories/AuthenticationRepository';
import EventBus from '../services/EventBus';
import { User } from '../models';
import { IonLoading } from '@ionic/react';

type AuthenticationWrapperProps = {
  children: ReactNode;
};

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  AuthenticationWrapperProps;

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  login: (params: AuthenticationParams) => dispatch(login(params)),
  logout: () => dispatch(logout())
});

const mapStateToProps = (state: {
  authentication: AuthenticationRootState;
}) => {
  return {
    isLoggedIn: !!state.authentication.accessToken,
    expirationDate: state.authentication.expirationDate
  };
};

const AuthenticationWrapper: React.FC<Props> = ({
  children,
  isLoggedIn,
  expirationDate,
  login,
  logout
}) => {
  const [loading, setLoading] = useState(false);
  const { instance: msalInstance, accounts } = useMsal();

  useEffect(() => {
    msalInstance.handleRedirectPromise().then((response) => {
      if (response) {
        setLoading(true);
        login({ accessToken: response.idToken })
          .then(({ user }: { user: User }) => {
            setLoading(false);
            EventBus.success(
              `Bienvenue chez Unilabs, ${user.patient.firstName}.`
            );
          })
          .catch((err: any) => {
            setLoading(false);
          });
      }
    });
  }, [login, msalInstance]);

  /* eslint-disable @typescript-eslint/no-unused-vars */
  const callSsoSilent = useCallback(async () => {
    try {
      const silentRequest = {
        scopes: ['openid', 'profile', 'offline_access'],
        account: accounts[0]
      };
      const response = await msalInstance.ssoSilent(silentRequest);
      if (response) {
        login({ accessToken: response.idToken }).then(
          ({ user }: { user: User }) => {
            setLoading(false);
            EventBus.success(
              `Bienvenue chez Unilabs, ${user.patient.firstName}.`
            );
          }
        );
      }
    } catch (e) {
      setLoading(false);
    }
  }, [accounts, login, msalInstance]);

  useEffect(() => {
    if (isLoggedIn) {
      if (expirationDate) {
        if (expirationDate.getTime() <= new Date().getTime()) {
          logout();
        } else {
          const timer = setTimeout(() => {
            logout();
          }, expirationDate.getTime() - new Date().getTime()); // automaticcaly logout after 1 hours
          return () => clearTimeout(timer);
        }
      }
      return () => null;
      // TODO: uncomment this code to use SSO but there is a reload of redirection page
      // } else if (!isLoggedIn) {
      //   const intervalCall = setInterval(callSsoSilent, 5000);
      //   return () => {
      //     clearInterval(intervalCall);
      //   };
    }
  }, [expirationDate, isLoggedIn, logout]);

  return (
    <>
      <IonLoading isOpen={loading} />
      {children}
    </>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticationWrapper);
